import React from "react";
import { useHistory } from "react-router-dom";
import { Flex, Text } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { globalEnv } from "~/global-env";
import { viewTextLabel, hoverViewWrapper } from "../styles_vanilla.css";
import { STATUS_CONFIG } from "./config";
import { arrowIcon, viewTextWrapper } from "./styles_vanilla.css";
import { ScreeningStatusProps } from "./types";

export const ScreeningStatus: React.FC<ScreeningStatusProps> = ({
  status,
  caseId,
  profileId,
  programId,
}): JSX.Element => {
  const history = useHistory();
  const config = STATUS_CONFIG[status];
  const isScreeningClickable =
    status !== "select-payment-beneficiary" && status !== "not-applicable";

  const handleClick = () => {
    if (isScreeningClickable && caseId && profileId) {
      const queryParam = `?profileId=${profileId}&programId=${programId}`;
      history.push(
        `${globalEnv.complianceRoute}/case/${caseId}/positions-screening-details${queryParam}`,
      );
    }
  };

  return (
    <Flex
      className={config.containerClass}
      onClick={handleClick}
      style={{
        cursor: isScreeningClickable ? "pointer" : "default",
      }}
    >
      {config.icon && (
        <Icon
          type={config.icon.type}
          variant={config.icon.variant}
          className={config.icon.className}
          data-testid={config.icon.type}
        />
      )}
      <Text className={config.text.className}>{config.text.content}</Text>
      {config.viewText && (
        <Flex
          role="link"
          className={
            status === "no-matches-found" ||
            status === "accepted-by-gp" ||
            status === "false-positive"
              ? hoverViewWrapper
              : viewTextWrapper
          }
        >
          <Text className={viewTextLabel}>{config.viewText}</Text>
          <Icon type="arrow-right" className={arrowIcon} data-testid="arrow-right" />
        </Flex>
      )}
    </Flex>
  );
};
